import LabelSelectBox from '@components/primitives/LabelSelectBox'
import type {
  BackgroundColor,
  BorderColor,
  TextColor,
} from '@lib/colors/colors'

export type Eligibility = 'Yes' | 'Unsure' | 'No' | undefined

const getItems = (isInclusion?: boolean) => {
  return [
    {
      backgroundColor: isInclusion ? 'bg-success100' : 'bg-destructive50',
      borderColor: isInclusion ? 'border-success400' : 'border-destructive400',
      color: isInclusion ? 'text-success800' : 'text-destructive400',
      label: 'Yes',
      value: 'Yes',
    },
    {
      backgroundColor: 'bg-warning50',
      borderColor: 'border-warning500',
      color: 'text-warning500',
      label: 'Unsure',
      value: 'Unsure',
    },
    {
      backgroundColor: isInclusion ? 'bg-destructive50' : 'bg-success100',
      borderColor: isInclusion ? 'border-destructive400' : 'border-success400',
      color: isInclusion ? 'text-destructive400' : 'text-success800',
      label: 'No',
      value: 'No',
    },
  ] as {
    backgroundColor: BackgroundColor
    borderColor: BorderColor
    color: TextColor
    label: string
    value: Eligibility
  }[]
}

export const IsEligiblePicker = ({
  isInclusion,
  setValue,
  value,
}: {
  isInclusion?: boolean
  setValue: (value: Eligibility) => void
  value: Eligibility
}) => {
  return (
    <LabelSelectBox
      className='rounded-lg border'
      instanceId='label-select-box'
      items={getItems(isInclusion)}
      menuClassNames='rounded-lg overflow-hidden shadow-lg cursor-pointer mt-1 border border-neutral200'
      minimized
      onChange={(value) => setValue(value as Eligibility)}
      optionClassNames='p-2 hover:bg-neutral100 cursor-pointer text-neutral600 bg-white border-neutral200'
      value={value}
    />
  )
}
